<template>
  <list-table
    :url="url"
    title="لیست تسویه ها"
    :fields="fields"
    :params="params"
  ></list-table>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
import persianDate from "../../helpers/persianDate";
export default {
  name: "Gardesh",
  data() {
    return {
      url: "getSattlments",
      fields: [
        {
          key: "nickname",
          label: "نام دارنده حساب",
        },
        {
          key: "bank_name",
          label: "نام بانک",
        },
        {
          key: "shaba_number",
          label: "شماره شبا",
        },
        {
          key: "created_at",
          label: "تاریخ ثبت",
          formatter(value, key, item) {
            return persianDate.getDateByFormat(value);
          },
        },
        {
          key: "tracking_number",
          label: "کد رهگیری",
        },
        {
          key: "bed",
          label: "مبلغ برداشتی",
        },
        {
          key: "setteled",
          label: "وضعیت",
          formatter(value, key, item) {
            var state = item.bed > 0 ? 3 : item.topic_id != 13 ? 2 : 1;
            return state == 3
              ? "تسویه شده"
              : state == 2
              ? "در حال تسویه"
              : "تسویه نشده";
          },
          tdClass(value,key,item){
              var state = item.bed > 0 ? 3 : item.topic_id != 13 ? 2 : 1;
            return state == 3
              ? "text-success"
              : state == 2
              ? "text-warning"
              : "text-danger";
          }
        },
      ],
      params: [],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "تسویه ها" }]);
  },
  components: {
    "list-table": TableShowData,
  },
};
</script>